<div
  class="d-flex justify-content-end"
  style="border-bottom: 2px solid #b4adad">
  <button class="btn blue-btn btn-sm mb-1 mr-4" (click)="PDFDownload()">
    Download
  </button>
  <button class="btn blue-btn btn-sm mb-1 mr-2" (click)="printForm()">
    Print
  </button>
</div>

<kendo-pdf-export #pdfAppealRequestForm paperSize="A4" margin="0.8cm">
  <div class="aucsheet mt-4" id="RequestForm">
    <div class="title d-flex justify-content-center">
      <h3 class="font-weight-bold">Appeal Request Form</h3>
    </div>
    <div class="tosheet mt-3 pb-2">
      <div class="mr-5 my-1">
        <h5 class="font-weight-bold">Billing Provider Information :</h5>
      </div>
      <div class="lables">
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0">Name:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0">ID Number:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0">Patient Account Number:</label>
          <input class="sheet-input col-5" />
        </div>
      </div>
    </div>
    <div class="tosheet mt-3 pb-2">
      <div class="mr-5 my-1">
        <h5 class="font-weight-bold">Claim Information:</h5>
      </div>
      <div class="lables">
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0">Patient Name:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0">Patient ID Number:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0">Date(s) of Service:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0">Payer Claim Number:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-5 pl-0"
            >Property and Casualty or<br />
            Workers Compensation Claim Number:</label
          >
          <input class="sheet-input   mt-4 col-5"/>
        </div>
      </div>
    </div>
    <div class="tosheet mt-3 pb-2">
      <div class="mr-5 my-1">
        <h5 class="font-weight-bold">Reason for Appeal Request:</h5>
      </div>
      <div class="lables">
        <div class="d-flex">
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Time Filing</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Pricing</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Eligibility</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Medical Policy</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Code Review</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Other</label>
          </div>
        </div>
        <div class="purchaser-option">
          <textarea class="txtarea col-6"></textarea>
        </div>
      </div>
    </div>
    <div class="tosheet mt-3 pb-2">
      <div class="mr-5 my-1">
        <h5 class="font-weight-bold">Supplemental Documentation:</h5>
      </div>
      <div class="lables">
        <div class="d-flex">
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Time Filing</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Pricing</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Eligibility</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Medical Policy</label>
          </div>
          <div class="fontsize">
            <input type="checkbox" class="sheet-input" />
            <label class="label-name mx-2 my-auto">Other</label>
          </div>
        </div>
        <div class="fontsize d-flex align-items-center mt-2">
          <label class="label-name mr-2">(describe):</label>
          <textarea class="txtarea col-6"></textarea>
        </div>
      </div>
    </div>
    <div class="tosheet mt-3 pb-2">
      <div class="mr-5 my-1">
        <h5 class="font-weight-bold">Contact Information:</h5>
      </div>
      <div class="lables">
        <div class="purchaser-option">
          <label class="label-name col-4 pl-0">Requester:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-4 pl-0">Date:</label>
          <input class="sheet-input col-5" />
        </div>
        <div class="purchaser-option">
          <label class="label-name col-4 pl-0">Contact Number:</label>
          <input class="sheet-input col-5" />
        </div>
      </div>
    </div>
  </div>
</kendo-pdf-export>
